var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.DynamicComponent)?_c(_setup.DynamicComponent,{tag:"component",attrs:{"formId":_setup.formId,"realSubId":_setup.realSubId,"op":_setup.op,"uid":_setup.uid,"submission":_setup.submission}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }